import { readLocal, saveLocal } from './localStorageHelper';

export const saveSession = (s) => saveLocal('nwm-session', s);
export const getSession = () => readLocal('nwm-session', null);
